"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useLanguage = void 0;
const LLContext_1 = require("./LLContext");
const react_1 = require("react");
exports.useLanguage = () => {
    const { languageId } = react_1.useContext(LLContext_1.llContext);
    return languageId;
};
//# sourceMappingURL=useLanguage.js.map